import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.apply.status');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-apply-status',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.apply.status/view.scss */
:host {
  display: block;
}`],
})
export class PageApplyStatusComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public application_id: string = '';
    public email: string = '';
    public loading: boolean = false;
    public errorMessage: string = '';
    public result: any = null;

    public statusLabels: any = {
        submitted: '접수 완료',
        reviewing: '심사중',
        approved: '승인',
        rejected: '반려',
        withdrawn: '취소',
    };

    public async ngOnInit() {
        await this.service.init();
    }

    public async lookup() {
        this.errorMessage = '';
        this.result = null;
        if (!this.application_id.trim() || !this.email.trim()) {
            this.errorMessage = '접수번호와 이메일을 모두 입력하세요.';
            await this.service.render();
            return;
        }
        this.loading = true;
        await this.service.render();
        const { code, data, message } = await wiz.call('lookup', {
            application_id: this.application_id.trim(),
            email: this.email.trim(),
        });
        this.loading = false;
        if (code !== 200) {
            this.errorMessage = message || '조회에 실패했습니다.';
            await this.service.render();
            return;
        }
        this.result = data.data || data;
        await this.service.render();
    }

    public statusLabel(s: string): string {
        return this.statusLabels[s] || s;
    }

    public reset() {
        this.result = null;
        this.application_id = '';
        this.email = '';
        this.errorMessage = '';
        this.service.render();
    }
}

export default PageApplyStatusComponent;